import { put, select } from "redux-saga/effects";

import { ScreenerStore } from "../model";
import { dataFilteredEtfsSet} from "../actions";
import { allFieldConfiguration } from "../../fields";

export function* filterTable() {
	const store: ScreenerStore = yield select();

	const filter = store.filter;
	const { currency, concreteEtfs } = store.preference;

	const etfs = concreteEtfs === null
		? store.data.etfs
		: store.data.etfs.filter(etf => concreteEtfs.indexOf(etf.ticker) != -1)

	const filteredEfs = allFieldConfiguration
		.reduce(
			(memo, field) => memo.filter(etf => field.isAcceptable(filter, etf, currency)), 
			etfs);

	yield put(dataFilteredEtfsSet(filteredEfs));
}
